export default "__VITE_PUBLIC_ASSET__cc1ad37a__"